import Axios from "../helper/appConfig";

export const getAllClassList = async (date) => {
  const search = [
    {
      searchfield: "onModel",
      searchvalue: "Groupclass",
      criteria: "eq",
      datatype: "text",
    },
    {
      searchfield: "status",
      searchvalue: ["requested", "cancel", "cancelled"],
      criteria: "nin",
      datatype: "text",
    },
  ];

  if (date) {
    search.push({
      searchfield: "bookingdate",
      searchvalue: date,
      criteria: "fullday",
      datatype: "Date",
    });
  }

  const body = {
    search: search,
    formname: "appointment",
    sort: {
      bookingdate: 1,
    },
  };

  return Axios.post("api/appointments/filter", body);
};
